module.exports = __webpack_public_path__ + "img/olhovazado-laranja.3f8ebf57.svg";